import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BucketIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 1.73053C11.3137 1.73053 14 3.28916 14 5.21183C14 5.38054 13.9793 5.54645 13.9393 5.70875L13.9403 5.70916L11.9789 13.5674C11.9623 13.6339 11.9321 13.6962 11.8903 13.7506C10.8709 15.0705 9.57414 15.7305 8 15.7305C6.42568 15.7305 5.13233 15.0704 4.11994 13.7501C4.09241 13.7142 4.06998 13.6748 4.0532 13.6331L4.03232 13.5689L2.07769 5.77354C2.02657 5.59069 2 5.40306 2 5.21183C2 3.28916 4.68629 1.73053 8 1.73053ZM8 2.72519C5.37665 2.72519 3.25 3.8385 3.25 5.21183C3.25 6.58517 5.37665 7.69848 8 7.69848C10.6234 7.69848 12.75 6.58517 12.75 5.21183C12.75 3.8385 10.6234 2.72519 8 2.72519Z"
		/>
	</svg>
))
